<template>
  <div :id="modalId" class="product-modal" uk-modal>
    <div class="uk-modal-dialog uk-margin-auto-vertical">
      <button class="uk-modal-close-default" type="button" uk-close></button>

      <div class="uk-modal-body">
        <div class="row">
          <div v-if="imageUrl" class="column">
            <img :src="imageUrl" :title="newlineToSpace(name)" :alt="newlineToSpace(name)" />
          </div>
          <div class="column">
            <h2 v-if="name">{{ name }}</h2>
            <p v-if="copy" class="copy">{{ copy }}</p>
            <p v-if="features">{{ features }}</p>
          </div>
        </div>

        <div class="actions uk-text-center">
          <a v-if="url" class="to-detail-page uk-button uk-button-primary uk-button-small" :href="url" target="_blank" v-wave>
            詳しい商品情報へ
            <i class="material-symbols-sharp" data-icon="chevron_right"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed, onMounted } from 'vue'
  import uikit from 'uikit'

  let modal: uikit.UIkitModalElement | null = null

  const props = defineProps({
    modalId: {
      type: String,
      required: true
    },
    // 商品名
    name: {
      type: String,
      required: false,
      default: null
    },
    // 商品のコピー
    copy: {
      type: String,
      required: false,
      default: null
    },
    // 商品の特長
    features: {
      type: String,
      required: false,
      default: null
    },
    // 商品ページURL
    url: {
      type: String,
      required: false,
      default: null
    },
    // 商品画像URL
    imageUrl: {
      type: String,
      required: false,
      default: null
    }
  })

  const modalId = computed(() => props.modalId)

  onMounted(() => {
    modal = uikit.modal(document.getElementById(modalId.value))
  })

  const open = () => {
    if (!modal) {
      return
    }
    modal.show()
  }

  defineExpose({
    open
  })

  /**
   * 改行を全角スペースに変換
   * @param {String} text 改行ありの文字列
   * @returns {String} 改行なしの文字列
   */
  const newlineToSpace = (text) => {
    return text.replaceAll("\n", "　")
  }
</script>

<style lang="scss" scoped>
  .uk-modal-dialog {

    .uk-modal-body {
      padding: 0.75rem;

      .row {
        display: flex;
        flex-direction: column;
        width: 100%;

        .column {
          flex: 1 1 auto;
          padding: 1rem 0.75rem 0;
          white-space: pre-wrap;

          img {
            max-height: 200px;
          }

          h2 {
            font-size: 1rem;
            font-weight: bold;
            margin-top: 0.25rem;
            margin-bottom: 0.25rem;
            color: #666;
          }

          p {
            font-size: 0.875rem;
            &.copy {
              font-size: 1rem;
              font-weight: bold;
            }
          }

          &:first-child {
            margin: 0 auto;
          }
        }
      }

      .actions {
        padding: 0.5rem 0;
        .to-detail-page {
          position: relative;
          color: var(--text-color);
          border: 1px solid var(--text-color);
          border-radius: 1rem;
          padding: 0 2rem 0 1rem;

          i {
            display: inline;
            position: absolute;
            right: 0.5rem;
            top: 50%;
            transform: translateY(-50%);
            opacity: 0.7;
          }
        }
      }
    }

    @media (min-width: 640px) {
      width: 400px;
    }
  }
</style>
